import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { decryption } from '../../common/enc_dec';
import { courseRatingReview } from '../../api/apiHandler';
import { Loading } from '../../components/loading/loading';
import ReactPaginate from "react-paginate";
import { useTranslation } from 'react-i18next';
import '../../i18'; 

const RatingReview = () => {
    const { t } = useTranslation();
    const params = useParams();
    const decryptedData = decryption(params.id);
    const [reviews, setReviews] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [pageToken, setPageToken] = useState(1);
    const [totalPage, setTotalPage] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            await getCourseRatingReview();
            setIsLoading(false);
        };
        fetchData();
    }, [pageToken]);

    const getCourseRatingReview = async () => {
        const response = await courseRatingReview({
            course_id: decryptedData.course_id,
            page: pageToken,
            limit: 12
        });
        if (response?.code === 200) {
            setReviews(response?.data?.data);
            setTotalPage(response?.data?.paging);
        }
    };

    const renderStars = (rating) => {
        const stars = [];
        const fullStars = Math.floor(rating);

        for (let i = 0; i < fullStars; i++) {
            stars.push(<i key={`full-${i}`} className="fa fa-star" />);
        }

        const emptyStarsCount = 5 - fullStars;
        for (let i = 0; i < emptyStarsCount; i++) {
            stars.push(<i key={`empty-${i}`} className="fa fa-star-o" />);
        }

        return stars;
    };

    const formatReviewDate = (date) => {
        const reviewDate = new Date(date);
        const currentDate = new Date();

        const diffInTime = currentDate - reviewDate;
        const diffInMinutes = Math.floor(diffInTime / (1000 * 60));
        const diffInHours = Math.floor(diffInTime / (1000 * 60 * 60));
        const diffInDays = Math.floor(diffInTime / (1000 * 3600 * 24));
        const diffInMonths = Math.floor(diffInDays / 30);

        if (diffInMinutes < 60) {
            return `${diffInMinutes} ${diffInMinutes !== 1 ? t('minutes') : t('minute')} ${t('ago')}`;
        } else if (diffInHours < 24) {
            return `${diffInHours} ${diffInHours !== 1 ? t('hours') : t('hour')} ${t('ago')}`;
        } else if (diffInDays < 30) {
            return `${diffInDays} ${diffInDays !== 1 ? t('days') : t('day')} ${t('ago')}`;
        } else {
            return `${diffInMonths} ${diffInMonths !== 1 ? t('months') : t('month')} ${t('ago')}`;
        }
    };

    const handlePageClick = (e) => {
        setPageToken(e.selected + 1)
    };

    if (isLoading) {
        return (
            <Loading />
        );
    }

    return (
        <>
            <div className="course-single-area pd-top-120 pd-bottom-90">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="CartMainBox">
                                <h2 className="CartHeading">{t('rateReviewHeading')}</h2>
                            </div>
                        </div>
                        {reviews.length > 0 && reviews.map((review) => (
                            <div key={review.id} className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 RateAndReviewGride">
                                <div className="RateAndReviewCard">
                                    <div className="RateAndReviewCardHeader">
                                        <ul className="RateAndReviewCardHeaderul">
                                            <li className="RateAndReviewCardHeaderLiOne">
                                                <div className="UserReviewImgBox">
                                                    <img
                                                        src={review.user_course_review.image || process.env.PUBLIC_URL + "/assets/img/author/1.png"} 
                                                        alt="review"
                                                        className="img-cover bor50per"
                                                    />
                                                </div>
                                                <div className="UserNameStarBox">
                                                    <h6 className="ReviewUsername">{review.user_course_review.full_name}</h6>
                                                    <div className="rating-inner">
                                                        {renderStars(review.rating)}
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="RateAndReviewCardHeaderLiTwo">
                                                <p className="DayAgotext">{formatReviewDate(review.review_date)}</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="RateAndReviewCardBody">
                                        <p className="ReviewText">{review.review}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {reviews.length === 0 && (
                            <h4 className='text-center mt-3 fw-light'>{t('noReviews')}</h4>
                        )}
                        {reviews && reviews.length > 0 && (
                            <ReactPaginate
                                className='pagination mt-4'
                                breakLabel="..."
                                nextLabel={`${t('next')} >`}
                                previousLabel={`< ${t('Previous')} `}
                                renderOnZeroPageCount={null}
                                onPageChange={handlePageClick}
                                pageCount={Math.ceil(totalPage.total / totalPage.page_limit)}
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default RatingReview;